"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var FileReference = /*#__PURE__*/function () {
  function FileReference(opt) {
    _classCallCheck(this, FileReference);

    this.id = null;
    this.original = null;
    this.contentType = null;
    this.filename = null;
    this.thumbnail = null;
    this.token = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(FileReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = new ObjectId(opt.id);
      this.original = opt.original ? new ObjectId(opt.original) : null;
      this.contentType = opt.contentType ? opt.contentType : null;
      this.filename = opt.filename ? opt.filename : null;
      this.thumbnail = opt.thumbnail ? opt.thumbnail : null;
      this.token = opt.token || null;
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'file-reference.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          id: {
            type: 'object'
          },
          original: {
            type: ['object', 'null']
          },
          contentType: {
            type: ['string', 'null']
          },
          filename: {
            type: ['string', 'null']
          },
          thumbnail: {
            type: ['string', 'null']
          },
          token: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return FileReference;
}();

module.exports = FileReference;